import { useSelector } from "react-redux";

const UseDocControlPermissions = () => {
  const { document_control } = useSelector(
    (state) => state.projectReducer.permissions
  );

  let canView = document_control?.view || false;
  let canEdit = document_control?.add_edit || false;
  let canExport = document_control?.export || false;
  let canDelete = document_control?.delete || false;

  return [canView, canEdit, canExport, canDelete];
};

export default UseDocControlPermissions;
